module.exports = __webpack_public_path__ + "static/media/expand.ea3ebe77.svg";